import { render, staticRenderFns } from "./FormObat.vue?vue&type=template&id=34596cdc&"
import script from "./FormObat.vue?vue&type=script&lang=js&"
export * from "./FormObat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports